import { SearchFacets } from 'api/graphQL/types/product.type'
import { processEnv } from 'components/configuration/environmentVariables'
import React from 'react'
import { ProductListingDialogFacet } from '..'
import { DialogWorkspaceHeader as NewDialogWorkspaceHeader } from './DialogWorkspaceHeader'
import { DialogWorkspaceHeader as OldDialogWorkspaceHeader } from './DialogWorkspaceHeader.old'

const DialogWorkspaceHeader =
    processEnv.REACT_APP_ShowUpdatedListingDialog === '1'
        ? NewDialogWorkspaceHeader
        : OldDialogWorkspaceHeader
interface DialogHeaderProps {
    category: string
    handleAutocompleteInputValueChange: (
        facet: ProductListingDialogFacet,
        value: string
    ) => void
    handleAutocompleteNameChange: (facet?: ProductListingDialogFacet) => void
    productTypeFacets: Partial<SearchFacets>[]
    autosuggestLoading?: boolean
    queryParams?: URLSearchParams
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({
    category,
    handleAutocompleteInputValueChange,
    handleAutocompleteNameChange,
    autosuggestLoading,
    queryParams,
    productTypeFacets,
}) => {
    return (
        <DialogWorkspaceHeader
            category={category ?? ''}
            productTypeFacets={productTypeFacets}
            handleAutocompleteNameChange={handleAutocompleteNameChange}
            handleAutocompleteInputValueChange={
                handleAutocompleteInputValueChange
            }
            autosuggestLoading={autosuggestLoading}
            queryParams={queryParams}
        />
    )
}
